<template>
  <div
    class="chart">
    <vue-c3
      :handler="handler"/>
  </div>
</template>

<script>
import Vue from 'vue';
import VueC3 from 'vue-c3';

require('c3/c3.css');

export default {
  name: 'XugarChart',
  components: {
    VueC3
  },
  props: {
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      handler: new Vue()
    };
  },
  watch: {
    data: {
      handler () {
        this.draw();
      },
      deep: true
    }
  },
  methods: {
    draw () {
      if (this.data === null || this.data === {}) {
        return;
      }

      const timestamps = this.getTimestamps();
      const dates = this.getDates(timestamps);

      const glucose = this.getGlucose(timestamps);
      const food = this.getFood(timestamps);
      const sport = this.getSport();
      const insulin = this.getInsulin();

      const options = {
        data: {
          x: 'x',
          xFormat: '%Y-%m-%d %H:%M',
          columns: [
            // ['x', '2020-12-01 9:00', '2020-12-01 10:00', '2020-12-01 11:00', '2020-12-01 12:00', '2020-12-01 13:00', '2020-12-01 14:00', '2020-12-01 15:00', '2020-12-01 16:00', '2020-12-01 17:00', '2020-12-01 18:00', '2020-12-01 19:00', '2020-12-01 20:00', '2020-12-01 21:00', '2020-12-01 22:00'],
            // ['Glucose', 60, 80, 140, 250, 40, 125, 300, 340, 240, 160, 120, 70, 50, 95, 140, 230, 200, 230, 240, 95, 160],
            ['x', ...dates],
            ['Glucose', ...glucose],
            ['IG_medium', ...food.medium],
            ['IG_low', ...food.low],
            ['IG_high', ...food.high]
            // ['IG_medium', 3, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 1],
            // ['IG_low', 2, 0, 0, 0, 0, 0, 4, 0, 3.5, 0, 0, 0, 0, 6],
            // ['IG_high', 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          ],
          type: 'bar',
          colors: {
            Glucose: '#283593',
            IG_medium: '#f57f17',
            IG_low: '#558b2f',
            IG_high: '#d50000'
          },
          types: {
            Glucose: 'line'
          },
          groups: [
            ['IG_medium', 'IG_low', 'IG_high']
          ],
          axes: {
            Glucose: 'y',
            IG_medium: 'y2',
            IG_low: 'y2',
            IG_high: 'y2'
          }
        },
        zoom: {
          /* Caution with the performance */
          enabled: false
        },
        bar: {
          width: {
            ratio: 0.1 // this makes bar width 50% of length between ticks
          }
          // or
          // width: 100 // this makes bar width 100px
        },
        line: {
          connectNull: true
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              fit: false,
              format: '%Y-%m-%d %H:%M'
            },
            label: 'Timestamp'
          },
          y2: {
            max: 20,
            show: true,
            label: 'Raciones HdC'
          },
          y: {
            label: 'Glucosa mg/dl'
          }
        },
        grid: {
          x: {
            lines: insulin
          }
        },
        regions: sport
      };

      this.handler.$emit('init', options);
    },
    getTimestamps () {
      const timestamps = [];
      this.data.food.forEach(food => timestamps.push(food.timestamp));
      this.data.glucose.forEach(glucose => timestamps.push(glucose.timestamp));
      this.data.insulin.forEach(insulin => timestamps.push(insulin.timestamp));
      this.data.sport.forEach(sport => timestamps.push(sport.timestamp));

      return timestamps.filter(onlyUnique).sort();
    },
    getDates (timestamps) {
      return timestamps.map(timestamp => new Date(timestamp));
    },
    getGlucose (timestamps) {
      const glucose = [];
      timestamps.forEach((timestamp, index) => {
        const item = this.data.glucose.find(glucose => glucose.timestamp === timestamp);
        const value = item ? item.value : null;
        glucose.push(value);
      });

      return glucose;
    },
    getFood (timestamps) {
      const lows = [];
      const mediums = [];
      const highs = [];

      timestamps.forEach(timestamp => {
        const food = this.data.food.find(food => food.timestamp === timestamp);

        let low = 0;
        let medium = 0;
        let high = 0;
        if (food) {
          for (let i = 0; i < food.pairs.length; i++) {
            switch (food.pairs[i].level) {
              case 'low':
                low += food.pairs[i].amount;
                break;
              case 'medium':
                medium += food.pairs[i].amount;
                break;
              case 'high':
                high += food.pairs[i].amount;
                break;
            }
          }
        }

        lows.push(low);
        mediums.push(medium);
        highs.push(high);
      });

      return {
        low: lows,
        medium: mediums,
        high: highs
      };
    },
    getSport () {
      return this.data.sport.map(sport => {
        return {
          start: new Date(sport.timestamp),
          end: new Date(sport.timestamp + sport.duration),
          opacity: 0.5
        };
      });
    },
    getInsulin () {
      return this.data.insulin.map(insulin => {
        return {
          value: insulin.timestamp,
          text: insulin.type,
          position: 'end'
        };
      });
    }
  }
};

const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";
</style>



// WEBPACK FOOTER //
// src/brand/xugarhero/components/explorer/XugarChart.vue